<template>
  <section class="info-page">
    <h2>Shipping information</h2>
    <div class="info-card">
      <p>We ship within the UK and supported European destinations.</p>
      <p>Delivery options and the final shipping cost are shown clearly at secure checkout, before you pay.</p>
      <p>Many of our pieces are made to order, so we carefully prepare each print before it is dispatched. If you need something for a particular date, please get in touch before ordering and we’ll do our best to help.</p>
      <router-link to="/shop" class="info-action">Browse the shop</router-link>
    </div>
  </section>
</template>

<style scoped>
.info-page {
  min-height: 55vh;
  padding: 44px 20px;
  background: #fff8ef;
  text-align: center;
}

.info-card {
  max-width: 650px;
  margin: 24px auto 0;
  padding: 26px;
  border-radius: 16px;
  background: white;
  box-shadow: 0 6px 20px rgba(46, 45, 97, 0.1);
  line-height: 1.6;
}

.info-action {
  display: inline-block;
  margin-top: 8px;
  padding: 11px 20px;
  border-radius: 999px;
  background: #2e2d61;
  color: white;
  font-weight: 700;
  text-decoration: none;
}
</style>
